import * as actionTypes from './actionTypes'

const initialState = {
  newsletterList: { newsletters: [], total: 0, pageSize: 0, error: null, loading: false },
  activeNewsletter: { newsletter: null, error: null, loading: false },
  newNewsletter: { newsletter: null, error: null, loading: false },
  updateNewsletter: { newsletter: null, error: null, loading: false },
  deleteNewsletter: { newsletter: null, error: null, loading: false }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_NEWSLETTERS:
      return {
        ...state,
        newsletterList: { ...state.newsletterList, error: null, loading: true }
      }
    case actionTypes.FETCH_NEWSLETTERS_SUCCESS:
      return {
        ...state,
        newsletterList: {
          newsletters: action.payload.newsletters,
          total: action.payload.total,
          pageSize: action.payload.pageSize,
          error: null,
          loading: false
        }
      }
    case actionTypes.FETCH_NEWSLETTERS_FAILURE:
      return {
        ...state,
        newsletterList: {
          newsletters: [],
          total: 0,
          pageSize: 0,
          error: action.payload.error,
          loading: false
        }
      }
    case actionTypes.RESET_NEWSLETTERS:
      return { ...state, newsletterList: initialState.newsletterList }

    case actionTypes.FETCH_NEWSLETTER:
      return { ...state, activeNewsletter: { newsletter: null, error: null, loading: true } }
    case actionTypes.FETCH_NEWSLETTER_SUCCESS:
      return {
        ...state,
        activeNewsletter: { newsletter: action.payload.newsletter, error: null, loading: false }
      }
    case actionTypes.FETCH_NEWSLETTER_FAILURE:
      return { ...state, activeNewsletter: { newsletter: null, error: action.payload.error, loading: false } }
    case actionTypes.RESET_NEWSLETTER:
      return { ...state, activeNewsletter: initialState.activeNewsletter }

    case actionTypes.CREATE_NEWSLETTER:
      return {
        ...state,
        newNewsletter: { newsletter: null, error: null, loading: true }
      }
    case actionTypes.CREATE_NEWSLETTER_SUCCESS:
      return {
        ...state,
        newNewsletter: { newsletter: action.payload.newsletter, error: null, loading: false }
      }
    case actionTypes.RESET_CREATE_NEWSLETTER:
      return {
        ...state,
        newNewsletter: initialState.newNewsletter
      }

    case actionTypes.UPDATE_NEWSLETTER:
      return {
        ...state,
        updateNewsletter: { newsletter: null, error: null, loading: true }
      }
    case actionTypes.UPDATE_NEWSLETTER_SUCCESS:
      return {
        ...state,
        updateNewsletter: { newsletter: action.payload.newsletter, error: null, loading: false }
      }
    case actionTypes.UPDATE_NEWSLETTER_FAILURE:
      return {
        ...state,
        updateNewsletter: { newsletter: null, error: action.payload.error, loading: false }
      }
    case actionTypes.RESET_UPDATE_NEWSLETTER:
      return {
        ...state,
        updateNewsletter: initialState.updateNewsletter
      }

    case actionTypes.DELETE_NEWSLETTER:
      return {
        ...state,
        deleteNewsletter: { newsletter: null, error: null, loading: true }
      }
    case actionTypes.DELETE_NEWSLETTER_SUCCESS:
      return {
        ...state,
        deleteNewsletter: { newsletter: action.payload.newsletter, error: null, loading: false }
      }
    case actionTypes.DELETE_NEWSLETTER_FAILURE:
      return {
        ...state,
        deleteNewsletter: { newsletter: null, error: action.payload.error, loading: false }
      }
    case actionTypes.RESET_DELETE_NEWSLETTER:
      return { ...state, deleteNewsletter: initialState.deleteNewsletter }

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/store/newsletter/reducer.js